import createReactComponent from '../createReactComponent';
export default createReactComponent('outline', 'prompt', 'IconPrompt', [["path",{"d":"M5 7l5 5l-5 5","key":"svg-0"}],["path",{"d":"M13 17l6 0","key":"svg-1"}]]);